import { Text, Icon, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { IconButton } from 'native-base';
import React from 'react';

import { HeaderProps } from '.';

export const HeaderMobile: React.FC<HeaderProps> = ({
  handleOpenInfo,
  isOpened,
  maturityDate,
  title,
}) => {
  return (
    <VStack space={Spacing['inline.nano']}>
      <HStack space={Spacing['inline.xxxs']} alignItems="center" justifyContent="space-between">
        <Text
          variant="semibold"
          numberOfLines={2}
          fontSize={Typography['fontsize.lg']}
          color="neutral.dark">
          {title}
        </Text>
        <IconButton
          p={0}
          variant="unstyled"
          onPress={handleOpenInfo}
          icon={
            <Icon
              testID="accordion-chevron-icon"
              name={isOpened ? 'ChevronUp' : 'ChevronDown'}
              size={'sm'}
              color={Color['neutral.dark']}
            />
          }
        />
      </HStack>

      <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.dark">
        Vencimento: {maturityDate}
      </Text>
    </VStack>
  );
};
